import { BentoBrand, BentoContact } from "schemas/dashboard";

import { GooglePlaceBrand } from "../schema";

export enum BrandStatus {
  loading = "loading",
  contactsFound = "contactsFound",
  contactsNotFound = "contactsNotFound",
}

export interface BrandVerificationData {
  googlePlaceBrand: GooglePlaceBrand;
  status: BrandStatus;
  bentoBrand?: BentoBrand;
  bentoContacts?: BentoContact[];
}
